export const binanceAccountCategory = 'binance'

/** Binance Japan のアカウントカテゴリ ID */
export const binanceJapanAccountCategory = 'binance-japan'

/** 同一 Binance API を利用する取引所ごとの識別情報 */
export type BinanceExchange = {
  /** アカウントカテゴリ ID (認証失敗エラーなどで利用) */
  accountCategory: string
  /** Action source / 資産 key の接頭辞 */
  sourcePrefix: string
}

/** Binance (Global) の識別情報 */
export const binanceExchange = {
  accountCategory: binanceAccountCategory,
  sourcePrefix: 'binance',
} as const satisfies BinanceExchange

/** Binance Japan の識別情報 */
export const binanceJapanExchange = {
  accountCategory: binanceJapanAccountCategory,
  sourcePrefix: 'binance_japan',
} as const satisfies BinanceExchange

export const networkEvmChainIds: Record<string, number | undefined> = {
  ARBITRUM: 42161,
  AVAXC: 43114,
  BASE: 8453,
  BERA: 80094,
  BSC: 56,
  ETH: 1,
  FTM: 250,
  GLMR: 1284,
  MANTA: 169,
  MATIC: 137,
  METIS: 1088,
  MOVR: 1285,
  OPBNB: 204,
  OPTIMISM: 10,
  RON: 2020,
  SCROLL: 534352,
  SONIC: 146,
  ZKSYNCERA: 324,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {
  ASTR: 2006,
  DOT: 0,
  STATEMINT: 1000,
}

export const solanaNetwork = 'SOL'
